import React, { useState, useEffect } from 'react';

export const TextToSpeech = ({ text }: { text: string }) => {
  const [isPaused, setIsPaused] = useState(false);
  const [utterance, setUtterance] = useState<null | SpeechSynthesisUtterance>(
    null
  );

  useEffect(() => {
    const synth = window.speechSynthesis;

    const handleVoicesChanged = () => {
      const u = new SpeechSynthesisUtterance(text);
      const voices = window.speechSynthesis.getVoices();
      const voice = voices.find(v => v.name.includes('Samantha') || v.default);
      if (voice && u !== null) u.voice = voice;
      setUtterance(u);
    };

    synth.addEventListener('voiceschanged', handleVoicesChanged);

    // Try setting utterance immediately as fallback
    // const fallback = new SpeechSynthesisUtterance(text);
    // setUtterance(fallback);

    return () => {
      synth.removeEventListener('voiceschanged', handleVoicesChanged);
      synth.cancel();
    };
  }, [text]);
  const handlePlay = () => {
    setClicked(true);
    const synth = window.speechSynthesis;

    if (isPaused) {
      synth.resume();
    }

    if (utterance !== null) {
      let utter = new window.SpeechSynthesisUtterance('Welcome,' + text);

      window.speechSynthesis.cancel();
      setTimeout(() => {
        window.speechSynthesis.speak(utter);
      }, 2000);
    } else {
      console.log('nullll');
    }

    setIsPaused(false);
  };

  const handlePause = () => {
    const synth = window.speechSynthesis;

    synth.pause();

    setIsPaused(true);
  };

  const handleStop = () => {
    const synth = window.speechSynthesis;

    synth.cancel();

    setIsPaused(false);
  };
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    handlePlay();
  }, [text]);
  return (
    <div>
      {!clicked && (
        <>
          <button onClick={handlePlay}>
            {isPaused ? 'Resume' : 'Play ' + text}
          </button>
          <button onClick={handlePause}>Pause</button>
          <button onClick={handleStop}>Stop</button>
        </>
      )}
    </div>
  );
};

export default TextToSpeech;
